import { toast } from "react-toastify";
import { getApiErrorMessage, getApiErrorStatus } from "../../../utils/apiError";

/**
 * Standard error handling for asset actions.
 * - 409 = the asset/assignment changed (someone else acted): toast, close the
 *   dialog (lists already refetch via the mutation), return null.
 * - anything else: return the message to show inside the form.
 */
export const handleAssetActionError = (
  err,
  { onConflict, conflictMessage } = {},
) => {
  if (getApiErrorStatus(err) === 409) {
    toast.info(
      conflictMessage || getApiErrorMessage(err, "Updated by someone else"),
    );
    onConflict?.();
    return null;
  }
  return getApiErrorMessage(err, "Something went wrong");
};

export { employeeName } from "../../../utils/text";
